export default {
      id: "i-logo-clean-usage",
      viewBox: "0, 0, 400,111.84911849118491",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-clean",
      toString: function () {
        return this.url;
      }
    }